var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.8961911874533234s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.692307692307693 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.8215085884988798s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461539 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.7468259895444361s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.07692307692308 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.6721433905899925s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923077 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.5974607916355489s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153845 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.5227781926811053s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.15384615384616 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.4480955937266617s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.37341299477221807s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846155 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.29873039581777444s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.22404779686333084s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.9230769230769 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.14936519790888722s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.61538461538464 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "-0.07468259895444361s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18.5,
    rx: 4,
    ry: 7.5,
    width: 8,
    height: 15,
    fill: "#ad9c83"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.970873786407767s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLoader);
export default __webpack_public_path__ + "static/media/spinner-loader.305bb89c48073abcb23b3714584418b7.svg";
export { ForwardRef as ReactComponent };